/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* CENTRUM „MOJE KUPONY” — /moje-kupony, /en/my-selections (Fala 6B-6D, 26.09.2026).
 *
 * Pelne centrum nad JEDNYM magazynem `pewniaki:moje-zestawy:v2` i JEDNYM API
 * window.PewniakiZestawy (assets/js/moje-zestawy.js). Nic tu nie tworzy drugiego
 * magazynu ani drugiego formularza:
 *   - akcje wiersza (sprawdz / analizuj / edytuj / duplikuj / usun + cofnij)
 *     = PewniakiZestawy.kontrolerAkcji — ten sam kod co w panelu 6A,
 *   - dodanie / edycja / duplikat = ten sam formularz w <dialog> panelu (panel()),
 *   - eksport / import = eksportujPlik / podepnijImport (import atomowy),
 *   - link #mk= zawiera kompaktowy Base64URL; fragment nie trafia do serwera,
 *     a import wymaga jawnego potwierdzenia odbiorcy.
 * 6B: grupowanie wg gry, wyszukiwanie po nazwie (lokalnie), sortowanie, filtr gry,
 *     ostatni wynik i nastepne losowanie z lokalnego /assets/json/db/index.json.
 * 6C: historia zestawu i porownanie dwoch zestawow TEJ SAMEJ gry na 25/50/100
 *     ostatnich losowaniach (PewniakiHistoria.ostatnie — pliki serwisu, zero
 *     zapytan do API Lotto). Eurojackpot: trafienia glowne i Euro osobno („3+1”).
 *     Blad/niepelny plik = stan bledu z ponowieniem, nigdy „0 trafien”.
 * 6D: dobrowolne powiadomienie przez istniejacy system PWA (sw.js, /pwa-api.php)
 *     — kanal „moje-kupony”: ogolny tekst, kod gry, link do centrum. Zgoda tylko
 *     po kliknieciu; po odmowie bez ponownego pytania.
 * Nazwy i liczby nie trafiaja do GA4, dataLayer, serwera ani logow. W linku
 * przenoszacym sa tylko w czesci po # (Base64URL to kodowanie, nie szyfrowanie).
 */
(function (root, doc) {
    'use strict';
    function start() {
        var MZ = root.PewniakiZestawy, H = root.PewniakiHistoria;
        var box = doc.querySelector('[data-mk-centrum]');
        if (!box || !MZ || !H || box.getAttribute('data-mkc-start') === '1') { return; }
        box.setAttribute('data-mkc-start', '1');
        var S = MZ.sklep(), en = /^en(?:-|$)/i.test(doc.documentElement.lang || ''), panel = MZ.panel();
        function T(pl, eng) { return en ? eng : pl; }
        function q(sel) { return box.querySelector(sel); }
        function el(tag, cls, tekst) { var x = doc.createElement(tag); if (cls) { x.className = cls; } if (tekst !== undefined) { x.textContent = tekst; } return x; }
        function wyczysc(w) { while (w.firstChild) { w.removeChild(w.firstChild); } }
        /** "2026-09-22T22:00:00+02:00" -> "2026-09-22 22:00" — czas z pliku, bez przeliczania strefy. */
        function kiedy(s) { s = typeof s === 'string' ? s : ''; return s ? s.slice(0, 10) + (s.length >= 16 ? ' ' + s.slice(11, 16) : '') : ''; }
        function data(iso) { var d = new Date(iso); return iso && !isNaN(d.getTime()) ? d.toLocaleDateString(jst("pages_moje_kupony_js.441bdbe22cf7")) : ''; }

        var stan = q('[data-mkc-stan]'), narzedzia = q('[data-mkc-narzedzia]'), lista = q('[data-mkc-lista]'), pusto = q('[data-mkc-pusto]');
        var zarzadzanie = q('[data-mkc-zarzadzanie]'), zgloszoneWyniki = {};
        var szukaj = q('[data-mkc-szukaj]'), sortuj = q('[data-mkc-sortuj]'), filtr = q('[data-mkc-filtr]');
        var dodaj = q('[data-mkc-dodaj]'), eksport = q('[data-mkc-eksport]'), linkB = q('[data-mkc-link]'), importB = q('[data-mkc-import]'), importPlik = q('[data-mkc-import-plik]');
        var qrB = q('[data-mkc-qr]'), drukB = q('[data-mkc-druk]'), wyczyscFiltry = q('[data-mkc-wyczysc-filtry]');
        var qrWrap = q('[data-mkc-qr-wrap]'), qrObraz = q('[data-mkc-qr-obraz]'), qrBlad = q('[data-mkc-qr-blad]'), qrZamknij = q('[data-mkc-qr-zamknij]');
        var linkOdbior = q('[data-mkc-link-odbior]'), linkTekst = q('[data-mkc-link-tekst]'), linkImport = q('[data-mkc-link-import]'), linkAnuluj = q('[data-mkc-link-anuluj]');
        function komunikat(t, blad) { stan.textContent = t || ''; stan.className = (blad ? 'blad-pola' : 'podpowiedz') + ' mkc__stan'; }

        function wszystkieZapisane() {
            var out = [];
            S.gry().forEach(function (kod) { S.lista(kod).forEach(function (z) { out.push({ kod: kod, z: z }); }); });
            return out;
        }
        function drukuj(zestawy) {
            if (!zestawy.length) { komunikat(jst("pages_moje_kupony_js.34a36ecad12b"), true); return; }
            // `noopener` moze celowo zwrocic `null` mimo poprawnego otwarcia,
            // przez co nie da sie zbudowac lokalnego widoku wydruku. Otwieramy
            // puste okno w obsludze klikniecia i od razu odcinamy `opener`.
            var w = root.open('', '_blank');
            if (!w) { komunikat(jst("pages_moje_kupony_js.0ded0a4a7e5e"), true); return; }
            try { w.opener = null; } catch (e) { /* nie blokuje bezpiecznego wydruku */ }
            var printCssUrl = new root.URL(box.getAttribute('data-mkc-print-css'), root.location.href).href;
            w.document.open();
            w.document.write('<!doctype html><html lang="' + (jst("pages_moje_kupony_js.5249530e0b6e")) + '"><head><meta charset="utf-8"><title>' + (jst("pages_moje_kupony_js.5aa52c9e65b1")) + jst("fragment.a0eed52147932b32") + printCssUrl + '"></head><body></body></html>');
            w.document.close();
            var h = w.document.createElement('h1'); h.textContent = jst("pages_moje_kupony_js.d43caaba9490"); w.document.body.appendChild(h);
            var prepared = w.document.createElement('p'); prepared.className = 'meta';
            prepared.textContent = (jst("pages_moje_kupony_js.f83e8ffb05bf")) + new Date().toLocaleString(jst("pages_moje_kupony_js.441bdbe22cf7"));
            w.document.body.appendChild(prepared);
            zestawy.forEach(function (x) {
                var section = w.document.createElement('section'); section.className = 'set';
                var title = w.document.createElement('h2'); title.textContent = S.reguly(x.kod).nazwa + ' — ' + x.z.name;
                var numbers = w.document.createElement('p'); numbers.className = 'nums'; numbers.textContent = x.z.numbers.join(' ');
                section.appendChild(title); section.appendChild(numbers);
                if (x.z.extra && x.z.extra.length) { var extra = w.document.createElement('p'); extra.className = 'nums'; extra.textContent = (jst("pages_moje_kupony_js.451ce34d1517")) + x.z.extra.join(' '); section.appendChild(extra); }
                w.document.body.appendChild(section);
            });
            var note = w.document.createElement('p'); note.className = 'meta';
            note.textContent = jst("pages_moje_kupony_js.33aa659a1327");
            w.document.body.appendChild(note);
            var printCss = w.document.querySelector('link[rel=stylesheet]');
            var doPrint = function () { try { w.focus(); w.print(); } catch (e) { /* widok pozostaje otwarty */ } };
            if (printCss.sheet) { root.setTimeout(doPrint, 0); } else { printCss.addEventListener('load', doPrint, { once: true }); }
        }
        var qrLadowanie = null;
        function zaladujQr() {
            if (typeof root.qrcode === 'function') { return root.Promise.resolve(); }
            if (qrLadowanie) { return qrLadowanie; }
            qrLadowanie = new root.Promise(function (resolve, reject) {
                var src = box.getAttribute('data-mkc-qr-lib');
                if (!src) { reject(new Error('src')); return; }
                var script = doc.createElement('script'); script.src = src; script.async = true;
                script.onload = function () { typeof root.qrcode === 'function' ? resolve() : reject(new Error('api')); };
                script.onerror = reject; doc.head.appendChild(script);
            });
            return qrLadowanie;
        }
        function pokazQr() {
            var transfer = MZ.utworzLink(S, en);
            wyczysc(qrObraz); qrBlad.hidden = true; qrBlad.textContent = '';
            qrWrap.hidden = false;
            if (!transfer.ok || transfer.url.length > 2600) {
                qrBlad.textContent = transfer.t || jst("pages_moje_kupony_js.ce397e036f79");
                if (transfer.url && transfer.url.length > 2600) { qrBlad.textContent = jst("pages_moje_kupony_js.ce397e036f79"); }
                qrBlad.hidden = false; qrZamknij.focus(); return;
            }
            zaladujQr().then(function () {
                var code = root.qrcode(0, 'M'); code.addData(transfer.url, jst("ui.6c19075dcbf5c456")); code.make();
                qrObraz.innerHTML = code.createSvgTag(4, 16, jst("pages_moje_kupony_js.97bfa85112ab"));
                var svg = qrObraz.querySelector('svg'); if (svg) { svg.setAttribute('role', 'img'); }
                qrZamknij.focus();
            }).catch(function () {
                qrBlad.textContent = jst("pages_moje_kupony_js.312334c55aa1"); qrBlad.hidden = false;
            });
        }

        S.gry().forEach(function (kod) { var o = el('option', '', S.reguly(kod).nazwa); o.value = kod; filtr.appendChild(o); });

        /* ── WYNIKI GIER: tylko lokalny index.json ── */
        var indeks = null, indeksBlad = false;
        function wczytajIndeks() {
            var url = box.getAttribute('data-mkc-indeks');
            if (!url || typeof root.fetch !== 'function') { indeksBlad = true; return; }
            root.fetch(url, { credentials: 'same-origin', cache: 'no-cache' })
                .then(function (r) { if (!r.ok) { throw new Error('http'); } return r.json(); })
                .then(function (d) {
                    indeks = {};
                    (d && Array.isArray(d.games) ? d.games : []).forEach(function (g) { if (g && typeof g.code === 'string') { indeks[g.code] = g; } });
                    // Ten sam harmonogram SSR co karty wyników; surowy indeks może mieć miniony termin.
                    var terminy={};try{terminy=JSON.parse(box.getAttribute('data-dj-terminy')||'{}');}catch(ignore){}
                    Object.keys(indeks).forEach(function(kod){var g=indeks[kod],t=terminy[kod];if((!g.next_draw||!Number.isFinite(Date.parse(g.next_draw))||Date.parse(g.next_draw)<=Date.now())&&typeof t==='string'&&Date.parse(t)>Date.now())g.next_draw=t;});
                    if (root.PewniakiDziennikWidok) { root.PewniakiDziennikWidok.update(indeks); }
                    rysuj();
                })
                .catch(function () { indeksBlad = true; rysuj(); });
        }
        function wynikGry(kod) {
            var p = el('div', 'mkc__gra-wynik');
            p.setAttribute('data-mkc-wynik-gry', kod);
            var g = indeks && indeks[kod];
            if (!g || !Array.isArray(g.numbers) || !g.numbers.length || typeof g.drawn_at !== 'string') {
                p.appendChild(el('p', 'tekst-maly', indeks === null && !indeksBlad ? jst("pages_moje_kupony_js.6850c8a8ecf6") : jst("pages_moje_kupony_js.4361a8b1267f")));
                if (indeks !== null || indeksBlad) { p.setAttribute('data-mkc-brak-wyniku', ''); }
                return p;
            }
            var w = el('p', 'tekst-maly', jst("pages_moje_kupony_js.329c3dde3710") + kiedy(g.drawn_at));
            p.appendChild(w);
            p.appendChild(MZ.kule(doc, en, kod, { numbers: g.numbers, extra: Array.isArray(g.special) && S.reguly(kod).dodatkowe ? g.special : [] }, null));
            if (typeof g.next_draw === 'string' && g.next_draw) { p.appendChild(el('p', 'tekst-maly', jst("pages_moje_kupony_js.531a6eb4ed2f") + kiedy(g.next_draw))); }
            return p;
        }

        /* ── AKCJE: ten sam kontroler co w panelu ── */
        var skrot = doc.querySelector('[data-mk-skrot]'), raporty = {};
        try { raporty = JSON.parse(skrot ? skrot.getAttribute('data-mk-raporty') || '{}' : '{}'); } catch (e) { /* ręczne wejście do raportu nadal działa */ }
        var akcje = MZ.kontrolerAkcji(doc, S, en, {
            korzen: lista, prefiks: 'c-', komunikat: komunikat, odswiez: function () { rysuj(); },
            cofnijWrap: q('[data-mkc-cofnij-wrap]'), cofnijPrzycisk: q('[data-mkc-cofnij]'),
            sprawdzarka: panel ? panel.sprawdzarka : '', analizatory: panel ? panel.analizatory : {},
            raporty: raporty,
            formularz: function (kod, z, kopiaZ, zrodlo) { otworzFormularz(kod, z, kopiaZ, zrodlo); },
            historia: function (kod, z) { wybierzDoHistorii(kod, z); },
            fokusZapasowy: function () { dodaj.focus(); }
        });
        function otworzFormularz(kod, z, kopiaZ, zrodlo) {
            if (!panel) { komunikat(jst("pages_moje_kupony_js.a5dabebf0819"), true); return; }
            panel.formularz(kod, z, kopiaZ, { poZapisie: function (t) { komunikat(t); }, powrot: zrodlo });
        }

        /* ── LISTA 6B ── */
        function klucz(z) { return z.updated || z.created || ''; }
        function porownajNazwy(a, b) { return a.name.localeCompare(b.name, jst("pages_moje_kupony_js.5249530e0b6e"), { sensitivity: 'base' }); }
        function rysujListe() {
            wyczysc(lista);
            var fraza = String(szukaj.value || '').trim().toLocaleLowerCase(), gra = filtr.value, sort = sortuj.value;
            var wszystkie = 0, widoczne = 0;
            S.gry().forEach(function (kod) {
                var l = S.lista(kod);
                wszystkie += l.length;
                if (!l.length || (gra && gra !== kod)) { return; }
                var pasujace = l.filter(function (z) { return !fraza || z.name.toLocaleLowerCase().indexOf(fraza) >= 0; });
                if (!pasujace.length) { return; }
                if (sort === 'nazwa') { pasujace.sort(porownajNazwy); }
                if (sort === 'edycja') { pasujace.sort(function (a, b) { return klucz(b).localeCompare(klucz(a)) || porownajNazwy(a, b); }); }
                widoczne += pasujace.length;
                var r = S.reguly(kod);
                var sekcja = el('section', "karta mkc__gra");
                sekcja.setAttribute('data-mkc-gra', kod);
                sekcja.setAttribute('aria-labelledby', 'mkc-gra-' + kod);
                var nag = el('div', 'mkc__gra-naglowek');
                var h = MZ.nazwaZGra(doc, el('h2', 'mkc__h2'), kod, r.nazwa); h.id = 'mkc-gra-' + kod;
                nag.appendChild(h); nag.appendChild(el('span', 'tekst-maly', MZ.liczbaZestawow(en, l.length) + ' / ' + MZ.LIMIT));
                sekcja.appendChild(nag);
                sekcja.appendChild(wynikGry(kod));
                var ul = el('ul', 'mkc__zestawy'); ul.setAttribute('role', 'list');
                pasujace.forEach(function (z) {
                    var li = el('li', 'mkc__zestaw'); li.setAttribute('data-mz-id', z.id);
                    li.appendChild(el('strong', 'mkc__nazwa', z.name));
                    var g = indeks && indeks[kod];
                    var maWynik = g && MZ.idLosowania((g.draw_system_id ?? g.legacy_id)) && typeof g.drawn_at === 'string' && !isNaN(Date.parse(g.drawn_at)) && Array.isArray(g.numbers) && g.numbers.length === r.pick && (!r.dodatkowe || (Array.isArray(g.special) && g.special.length === r.dodatkowe.ile)) && S.normalizuj(kod, g.numbers, r.dodatkowe ? g.special : []).ok;
                    var trafienia = maWynik ? S.porownaj(z, g.numbers, r.dodatkowe ? g.special : []) : null;
                    li.appendChild(MZ.kule(doc, en, kod, z, trafienia));
                    var opisTrafien = jst("pages_moje_kupony_js.93f00343eae7") + (trafienia
                        ? MZ.tekst(en, 'trafienia', trafienia.glowne, z.numbers.length) + (r.dodatkowe ? '; ' + MZ.tekst(en, 'trafieniaDod', trafienia.dodatkowe, z.extra.length) : '') + ' — ' + kiedy(g.drawn_at) + jst("pages_moje_kupony_js.5295ff132ac0") + (g.draw_system_id ?? g.legacy_id)
                        : jst("pages_moje_kupony_js.879a414322a4"));
                    var podsumowanie = el('p', 'mkc__meta', opisTrafien);
                    podsumowanie.setAttribute('data-mkc-trafienia', trafienia ? String(trafienia.glowne) + (r.dodatkowe ? '+' + trafienia.dodatkowe : '') : 'brak');
                    li.appendChild(podsumowanie);
                    if (trafienia && !zgloszoneWyniki[kod + ':' + (g.draw_system_id ?? g.legacy_id)]) {
                        zgloszoneWyniki[kod + ':' + (g.draw_system_id ?? g.legacy_id)] = true;
                        S.zdarzenie('my_ticket_check_latest', kod, 'centrum', l.length);
                    }
                    var meta = [];
                    if (z.created) { meta.push(jst("pages_moje_kupony_js.1dae680ecbaf") + data(z.created)); }
                    if (z.updated) { meta.push(jst("pages_moje_kupony_js.4be6efe082aa") + data(z.updated)); }
                    if (meta.length) { li.appendChild(el('span', "tekst-maly mkc__meta", meta.join(' · '))); }
                    var wierszAkcji = akcje.wiersz(kod, z), doRaportu = wierszAkcji.querySelector('[data-mk-akcja="raport"]');
                    if (doRaportu) { doRaportu.textContent = jst("pages_moje_kupony_js.b666f55fc475"); }
                    li.appendChild(wierszAkcji);
                    if (root.PewniakiDziennikWidok) { li.appendChild(root.PewniakiDziennikWidok.card(kod,z)); }
                    var drukJeden = el('button', jst("ui.a6cee88e9f59ccc6"), jst("pages_moje_kupony_js.634c78369dfc")); drukJeden.type = 'button';
                    drukJeden.addEventListener('click', function () { drukuj([{ kod: kod, z: z }]); }); li.appendChild(drukJeden);
                    var udostepnijJeden = el('button', 'przycisk', jst("pages_moje_kupony_js.e78f4bd0ad7c")); udostepnijJeden.type = 'button';
                    udostepnijJeden.setAttribute('data-mkc-share', kod + ':' + z.id); li.appendChild(udostepnijJeden);
                    ul.appendChild(li);
                });
                sekcja.appendChild(ul);
                lista.appendChild(sekcja);
            });
            return { wszystkie: wszystkie, widoczne: widoczne };
        }

        var ostrzezenieUszkodzony = false;
        function rysuj() {
            var dostepny = S.dostepny();
            narzedzia.hidden = false;
            [dodaj, importB].forEach(function (b) { b.disabled = !dostepny; });
            var n = rysujListe();
            q('[data-mkc-filtry]').hidden = !n.wszystkie;
            q('#mkc-link-opis').hidden = !n.wszystkie;
            eksport.hidden = !n.wszystkie;
            linkB.hidden = !n.wszystkie;
            qrB.hidden = !n.wszystkie;
            drukB.hidden = !n.wszystkie;
            pusto.hidden = n.widoczne > 0;
            if (!dostepny) {
                pusto.textContent = jst("pages_moje_kupony_js.4fb2b668096d");
            } else if (!n.wszystkie) {
                pusto.textContent = jst("pages_moje_kupony_js.ee62e162c03e");
            } else if (!n.widoczne) {
                pusto.textContent = jst("pages_moje_kupony_js.2d1767148b40");
            }
            pusto.setAttribute('data-mkc-pusto', !dostepny ? 'niedostepny' : (!n.wszystkie ? 'pusty' : 'filtr'));
            wyczyscFiltry.hidden = !n.wszystkie || n.widoczne > 0;
            if (!ostrzezenieUszkodzony && dostepny && S.stan() === 'uszkodzony') {
                ostrzezenieUszkodzony = true;
                komunikat(jst("pages_moje_kupony_js.d981a702eb2d"), true);
            }
            odswiezHistorie();
        }

        szukaj.addEventListener('input', rysujListeIPusto);
        sortuj.addEventListener('change', rysujListeIPusto);
        filtr.addEventListener('change', rysujListeIPusto);
        wyczyscFiltry.addEventListener('click', function () { szukaj.value = ''; filtr.value = ''; sortuj.value = 'gra'; rysujListeIPusto(); zarzadzanie.open = true; szukaj.focus(); });
        function rysujListeIPusto() { akcje.reset(); rysuj(); }
        dodaj.addEventListener('click', function () { akcje.wyczyscCofnij(); otworzFormularz(filtr.value || null, null, null, dodaj); });
        eksport.addEventListener('click', function () { akcje.wyczyscCofnij(); var k = MZ.eksportujPlik(doc, S, en, box); komunikat(k.t, k.zly); });
        linkB.addEventListener('click', function () {
            akcje.wyczyscCofnij(); linkB.disabled = true;
            MZ.udostepnijLink(doc, S, en).then(function (k) {
            linkB.disabled = false; komunikat(k.t, k.zly); linkB.focus();
            });
        });
        qrB.addEventListener('click', pokazQr);
        qrZamknij.addEventListener('click', function () { qrWrap.hidden = true; wyczysc(qrObraz); qrB.focus(); });
        drukB.addEventListener('click', function () { drukuj(wszystkieZapisane()); });
        importB.addEventListener('click', function () { akcje.wyczyscCofnij(); importPlik.click(); });
        MZ.podepnijImport(S, en, importPlik, function (k) { rysuj(); komunikat(k.t, k.zly); importB.focus(); });

        var daneZLinku = MZ.odczytajLink(S);
        if (daneZLinku) {
            if (!daneZLinku.ok) { komunikat(MZ.teksty6(en, 'linkNiepoprawny'), true); MZ.usunFragment(); }
            else {
                linkTekst.textContent = MZ.teksty6(en, 'linkOdebrany', daneZLinku.ile);
                var podglad = q('[data-mkc-link-podglad]');
                daneZLinku.pakiet.games.forEach(function (g) { g.sets.forEach(function (z) {
                    var karta = el('section', 'mkc__hist-karta');
                    karta.appendChild(MZ.nazwaZGra(doc, el('h3', 'mkc__h3'), g.game, S.reguly(g.game).nazwa + ' — ' + z.name));
                    karta.appendChild(MZ.kule(doc, en, g.game, z, null)); podglad.appendChild(karta);
                }); });
                linkOdbior.hidden = false; linkImport.focus();
                linkImport.addEventListener('click', function () {
                    var k = MZ.importujLink(S, en, daneZLinku); linkOdbior.hidden = true; MZ.usunFragment(); rysuj(); komunikat(k.t, k.zly); importB.focus();
                });
                linkAnuluj.addEventListener('click', function () { linkOdbior.hidden = true; MZ.usunFragment(); komunikat(jst("pages_moje_kupony_js.cca834f74be3")); dodaj.focus(); });
            }
        }

        /* ── HISTORIA 6C ── */
        var hSekcja = q('[data-mkc-historia]'), hForm = q('[data-mkc-historia-form]'), hA = q('[data-mkc-hist-a]'), hB = q('[data-mkc-hist-b]');
        var hBlad = q('[data-mkc-hist-blad]'), hWynik = q('[data-mkc-hist-wynik]'), hCache = {}, hZadanie = 0;
        var C = JSON.parse(hSekcja.getAttribute('data-compare-text'));
        var threshold = q('[data-compare-threshold]'), price = q('[data-compare-price]'), prizesCache = {};
        function invalidate() { hZadanie++; wyczysc(hWynik); hWynik.appendChild(el('p','tekst-maly',C.changed)); }
        hForm.addEventListener('input', invalidate);
        hForm.addEventListener('change', invalidate);
        doc.addEventListener(MZ.ZDARZENIE, invalidate);
        function wszystkieZestawy() {
            var out = [];
            S.gry().forEach(function (kod) { S.lista(kod).forEach(function (z) { out.push({ kod: kod, z: z }); }); });
            return out;
        }
        function opcja(x) { var o = el('option', '', S.reguly(x.kod).nazwa + ' — ' + x.z.name); o.value = x.kod + ':' + x.z.id; return o; }
        function odswiezHistorie() {
            var wszystkie = wszystkieZestawy(), a = hA.value, b = hB.value;
            hSekcja.hidden = !wszystkie.length;
            wyczysc(hA); wyczysc(hB);
            wszystkie.forEach(function (x) { hA.appendChild(opcja(x)); });
            if (wszystkie.some(function (x) { return x.kod + ':' + x.z.id === a; })) { hA.value = a; }
            var brak = el('option', '', jst("pages_moje_kupony_js.4ba09c410bbf")); brak.value = ''; hB.appendChild(brak);
            var grupy = {};
            wszystkie.forEach(function (x) {
                if (x.kod + ':' + x.z.id === hA.value) { return; }
                if (!grupy[x.kod]) { grupy[x.kod] = el('optgroup'); grupy[x.kod].label = S.reguly(x.kod).nazwa; hB.appendChild(grupy[x.kod]); }
                grupy[x.kod].appendChild(opcja(x));
            });
            hB.value = wszystkie.some(function (x) { return x.kod + ':' + x.z.id === b; }) && b !== hA.value ? b : '';
        }
        hA.addEventListener('change', function () { odswiezHistorie(); });
        function wybierzDoHistorii(kod, z) {
            hA.value = kod + ':' + z.id; odswiezHistorie();
            if (typeof hSekcja.scrollIntoView === 'function') { try { hSekcja.scrollIntoView({ block: 'start' }); } catch (e) { /* nic */ } }
            hA.focus();
        }
        function zestawZ(v) {
            var i = String(v || '').indexOf(':'); if (i < 0) { return null; }
            var kod = v.slice(0, i), id = v.slice(i + 1), z = S.lista(kod).filter(function (x) { return x.id === id; })[0];
            return z ? { kod: kod, z: z } : null;
        }
        function hBladPokaz(t) { hBlad.textContent = t || ''; hBlad.hidden = !t; }
        function ocena(draws, z, zDod) {
            var w = H.policz(draws, z.numbers, zDod ? z.extra : []);
            var best = null, ostatnie = null, gl = z.numbers.length, dd = zDod ? z.extra.length : 0, macierz = [];
            for (var i = 0; i <= gl; i++) { macierz.push([]); for (var j = 0; j <= dd; j++) { macierz[i].push(0); } }
            w.forEach(function (x) {
                macierz[x.t][Math.min(x.ts, dd)]++;
                if (!best || x.t > best.t || (x.t === best.t && x.ts > best.ts)) { best = x; }
                if (!ostatnie && (x.t > 0 || x.ts > 0)) { ostatnie = x; }
            });
            if (best) { best = w.filter(function (x) { return x.t === best.t && x.ts === best.ts; })[0]; }   // najnowsze wystapienie najlepszego wyniku
            return { w: w, best: best, ostatnie: ostatnie, macierz: macierz, gl: gl, dd: dd };
        }
        function wynikTekst(o, x) { return o.dd ? x.t + '+' + x.ts : String(x.t); }
        function tabela(podpis, naglowki, wiersze, atrybut) {
            var sc = el('div', 'tabela-scroll'), t = el('table', 'tabela'), cap = el('caption', '', podpis), th = el('thead'), tr = el('tr'), tb = el('tbody');
            if (atrybut) { t.setAttribute(atrybut, ''); }
            naglowki.forEach(function (h) { var c = el('th', '', h); c.scope = 'col'; tr.appendChild(c); });
            th.appendChild(tr); t.appendChild(cap); t.appendChild(th);
            wiersze.forEach(function (w) { var r = el('tr'); w.forEach(function (v, i) { var c = el(i === 0 ? 'th' : 'td', i === 0 ? '' : 'liczbowa', String(v)); if (i === 0) { c.scope = 'row'; } r.appendChild(c); }); tb.appendChild(r); });
            t.appendChild(tb); sc.appendChild(t); return sc;
        }
        /** Wiersze histogramu: Lotto itp. 0..k; Eurojackpot tylko pary glowne+Euro, ktore wystapily u ktoregos z zestawow (plus 0+0). */
        function wierszeHistogramu(oceny) {
            var o0 = oceny[0], out = [];
            if (!o0.dd) {
                var maks = Math.max.apply(null, oceny.map(function (o) { return o.gl; }));
                for (var i = 0; i <= maks; i++) { out.push([String(i)].concat(oceny.map(function (o) { return i <= o.gl ? o.macierz[i][0] : 0; }))); }
                return out;
            }
            for (var t = 0; t <= o0.gl; t++) {
                for (var s = 0; s <= o0.dd; s++) {
                    var wart = oceny.map(function (o) { return (o.macierz[t] && o.macierz[t][s]) || 0; });
                    if ((t === 0 && s === 0) || wart.some(function (v) { return v > 0; })) { out.push([t + '+' + s].concat(wart)); }
                }
            }
            return out;
        }
        function karta(x, o) {
            var k = el('section', 'mkc__hist-karta'); k.setAttribute('data-mkc-hist-zestaw', x.kod + ':' + x.z.id);
            k.appendChild(el('h3', 'mkc__h3', x.z.name));
            k.appendChild(MZ.kule(doc, en, x.kod, x.z, null));
            var naj = el('p', '', '');
            if (!o.best || (o.best.t === 0 && o.best.ts === 0)) {
                naj.textContent = jst("pages_moje_kupony_js.574a62747774");
                naj.setAttribute('data-mkc-najlepszy', o.dd ? '0+0' : '0');
            } else {
                naj.setAttribute('data-mkc-najlepszy', wynikTekst(o, o.best));
                naj.textContent = jst("pages_moje_kupony_js.ad92181fcc38") + (o.dd
                    ? wynikTekst(o, o.best) + jst('moje_kupony.euro_result', [o.best.t, o.gl, o.best.ts, o.dd])
                    : o.best.t + jst("pages_moje_kupony_js.7ea135d87cc8") + o.gl) + jst("pages_moje_kupony_js.bbbb7ca0f83e") + kiedy(o.best.d.drawn_at) + '.';
            }
            k.appendChild(naj);
            var ost = el('p', '', o.ostatnie ? jst("pages_moje_kupony_js.68ddfc770d63") + kiedy(o.ostatnie.d.drawn_at) + ' (' + wynikTekst(o, o.ostatnie) + ').' : jst("pages_moje_kupony_js.1ad8eb7299fd"));
            ost.setAttribute('data-mkc-ostatnie', o.ostatnie ? kiedy(o.ostatnie.d.drawn_at) : '');
            k.appendChild(ost);
            var det = el('details', 'mkc__os');
            det.appendChild(el('summary', '', jst("pages_moje_kupony_js.dbeba7edc7d5")));
            var slupki = el('div', 'mkc__slupki'); slupki.setAttribute('aria-hidden', 'true');
            o.w.slice().reverse().forEach(function (y) { var s = el('span', 'mkc__slupek'); s.style.height = (4 + Math.round(36 * (y.t + y.ts) / Math.max(1, o.gl + o.dd))) + 'px'; slupki.appendChild(s); });
            det.appendChild(slupki);
            det.appendChild(tabela(jst("pages_moje_kupony_js.e80d20696d16"), [jst("pages_moje_kupony_js.3743aa56390a"), jst("pages_moje_kupony_js.916138ecbd76")], o.w.map(function (y) { return [kiedy(y.d.drawn_at), wynikTekst(o, y)]; }), 'data-mkc-os'));
            k.appendChild(det);
            return k;
        }
        function historia(all) {
            hBladPokaz('');
            var A = zestawZ(hA.value), B = hB.value ? zestawZ(hB.value) : null;
            if (!A) { hBladPokaz(jst("pages_moje_kupony_js.8049fbf648bc")); return; }
            if (hB.value && !B) { hBladPokaz(tekstBrak()); return; }
            if (B && B.kod !== A.kod) { hBladPokaz(jst("pages_moje_kupony_js.f7dadb78fd4d")); return; }
            var zakresEl = hForm.querySelector('[data-mkc-zakres]:checked'), n = zakresEl ? parseInt(zakresEl.value, 10) : 50;
            if ([7, 14, 25, 50, 100, 250, 500].indexOf(n) < 0) { n = 50; }
            if (B && B.z.numbers.length !== A.z.numbers.length && !all) { hBladPokaz(C.same); return; }
            var xs = all ? wszystkieZestawy().filter(function(x){return x.kod===A.kod && x.z.numbers.length===A.z.numbers.length;}) : (B ? [A,B] : [A]);
            if(all && xs.length<2){hBladPokaz(C.few);return;}
            var prog=Number(threshold.value), cena=price.value.trim()===''?null:Number(price.value);
            if(!Number.isInteger(prog)||prog<1||prog>A.z.numbers.length||(cena!==null&&(!Number.isFinite(cena)||cena<0.01||cena>1000))){hBladPokaz(C.invalid);return;}
            var moje = ++hZadanie, r = S.reguly(A.kod), zDod = !!r.dodatkowe;
            wyczysc(hWynik); hWynik.appendChild(el('p', 'tekst-maly', jst("pages_moje_kupony_js.e1d7fab6c3ea")));
            H.ostatnie({ kod: A.kod, n: n, cache: hCache[A.kod] || (hCache[A.kod] = {}) }).then(function(p){
                return Promise.all([H.pobierzWygrane({draws:p.draws,recent:p.draws,kod:A.kod,cache:prizesCache,complete:true}),
                    ['multi-multi','kaskada'].indexOf(A.kod)>=0 ? root.fetch('/assets/json/db/'+A.kod+'/stawki.json').then(function(r){if(!r.ok)throw Error('rates');return r.json();}).then(function(d){return d.stopnie||{};}).catch(function(){return {};}) : Promise.resolve({})
                ]).then(function(v){return {draws:v[0].draws,zakres:p.zakres,stawki:v[1]};});
            }).then(function (p) {
                if (moje !== hZadanie) { return; }
                wyczysc(hWynik);
                var podsum = el('p', '', jst("pages_moje_kupony_js.4203bfcb2a5d") + p.draws.length + jst("pages_moje_kupony_js.343ff8761638") + kiedy(p.zakres.od) + jst("pages_moje_kupony_js.dca36ca90b18") + kiedy(p.zakres.do) + ').');
                podsum.setAttribute('data-mkc-hist-n', String(p.draws.length));
                hWynik.appendChild(podsum);
                var oceny = xs.map(function (x) { return ocena(p.draws, x.z, zDod); });
                if (zDod) { hWynik.appendChild(el('p', 'tekst-maly', jst("pages_moje_kupony_js.175bd595fb60"))); }
                hWynik.appendChild(tabela(
                    jst("pages_moje_kupony_js.d60063d34852"),
                    [jst("pages_moje_kupony_js.916138ecbd76")].concat(xs.map(function (x) { return x.z.name; })),
                    wierszeHistogramu(oceny), 'data-mkc-histogram'));
                if (B && !all) {
                    var a = oceny[0].best, b = oceny[1].best;
                    var remis = a.t === b.t && a.ts === b.ts;
                    var por = el('p', 'mkc__porownanie', remis
                        ? jst("pages_moje_kupony_js.9ce501caed19") + wynikTekst(oceny[0], a) + jst("pages_moje_kupony_js.8628b22eab27")
                        : jst("pages_moje_kupony_js.b8aad621be5e") + A.z.name + jst("pages_moje_kupony_js.72f472b1453a") + wynikTekst(oceny[0], a) + jst("pages_moje_kupony_js.a13b2f453b38") + B.z.name + jst("pages_moje_kupony_js.72f472b1453a") + wynikTekst(oceny[1], b) + '.');
                    por.setAttribute('data-mkc-remis', remis ? '1' : '0');
                    hWynik.appendChild(por);
                }
                hWynik.appendChild(el('p','',C.range.replace('%1',xs.length).replace('%2',p.draws.length)));
                hWynik.appendChild(tabela(C.all,[C.set,C.success,C.run,C.gap,C.current],xs.map(function(x,i){var z=H.serie(oceny[i].w,prog);return [x.z.name,z.sukcesy,z.seria,z.przerwa,z.biezaca];}),'data-compare-series'));
                hWynik.appendChild(el('h3','',C.finance));
                hWynik.appendChild(el('p','tekst-maly',C.financeNote));
                var balances=xs.map(function(x,i){return H.bilans(A.kod,oceny[i].w,x.z.numbers.length,cena,p.stawki);});
                function money(v){return v===null?'—':v.toLocaleString(en?'en-GB':'pl-PL',{minimumFractionDigits:2,maximumFractionDigits:2})+' PLN';}
                hWynik.appendChild(tabela(C.finance,[C.set,C.cost,C.known,C.balance,C.complete],xs.map(function(x,i){var z=balances[i];return [x.z.name,money(z.koszt),money(z.suma),z.brak?C.missing:money(z.saldo),(p.draws.length-z.brak)+' / '+p.draws.length];}),'data-compare-finance'));
                if(cena===null)hWynik.appendChild(el('p','',C.noCost));
                xs.forEach(function (x, i) {
                    var card=karta(x,oceny[i]),details=el('details','mkc__os');
                    details.appendChild(el('summary','',C.details));
                    details.appendChild(tabela(C.details,[C.date,C.hits,C.amount],balances[i].rows.map(function(z){return [kiedy(z.date),String(z.hits)+(zDod?' + '+z.extra:''),z.amount===null?C.unknown:money(z.amount)];}),'data-compare-payouts'));
                    card.appendChild(details);hWynik.appendChild(card);
                });
                S.zdarzenie('my_ticket_history', A.kod, 'centrum', S.lista(A.kod).length);
                hWynik.appendChild(el('p', 'tekst-maly', jst("pages_moje_kupony_js.5ef7819f50d7")));
            }).catch(function () {
                if (moje !== hZadanie) { return; }
                wyczysc(hWynik);
                var b = el('p', 'blad-pola', jst("pages_moje_kupony_js.9fc74dc3f74e"));
                b.setAttribute('data-mkc-hist-blad-pobrania', '');
                hWynik.appendChild(b);
                var ponow = el('button', 'przycisk', jst("pages_moje_kupony_js.5ee85dc1aa04")); ponow.type = 'button'; ponow.setAttribute('data-mkc-hist-ponow', '');
                ponow.addEventListener('click', function(){historia(all);});
                hWynik.appendChild(ponow);
            });
        }
        function tekstBrak() { return jst("pages_moje_kupony_js.14b72f70acc9"); }
        hForm.addEventListener('submit', function (e) { e.preventDefault(); historia(false); });
        q('[data-compare-all]').addEventListener('click',function(){historia(true);});

        doc.addEventListener(MZ.ZDARZENIE, rysuj);
        rysuj();
        wczytajIndeks();
    }

    if (doc.documentElement.getAttribute('data-mz-gotowe') === '1') { start(); } else { doc.addEventListener('pewniaki:zestawy-gotowe', start); }
})(window, document);
